// @flow
import React from 'react';
import type { Node } from 'react';
import _get from 'lodash-es/get';

import ContactInfo from './ContactInfo';

type ContactProps = {
  personSummary: any,
  savePersonSummaryPrivate: ({ personData: any, personUrl: string }) => void,
  isContactComplete: boolean,
};

const ContactInfoContainer = (props: ContactProps): Node => (
  <>{_get(props.personSummary, 'private', false) ? <ContactInfo {...props} /> : null}</>
);
export default ContactInfoContainer;



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/EmergencyFormPage/components/ContactInfo/ContactInfoContainer.jsx